import { toast } from "react-hot-toast";

import { setLoading, setToken } from "../../redux/slices/authSlice";
import { clearUser, setUser } from "../../redux/slices/profileSlice";
import { apiConnector } from "../apiConnector";
import { endpoints } from "../apis";

const {
  SIGNUP_API,
  LOGIN_API,
  GET_USER_API,
  EDIT_USER_API,
  RESETPASSTOKEN_API,
  RESETPASSWORD_API,
  GET_USER_BY_ID_API,
  SENDOTP_API,
  GET_ALL_STUDENT_API,
  GET_ALL_TEACHER_API,
  EDIT_USER_ADMIN_API,
  GET_ALL_USERS_API,
  DELETE_USER_API,
  REGISTER_API,
  GET_SCHOOL_USERS_API,
} = endpoints;

export function getPasswordResetToken(email, setEmailSent) {
  return async (dispatch) => {
    const toastId = toast.loading("Loading...");
    dispatch(setLoading(true));
    try {
      const response = await apiConnector("POST", RESETPASSTOKEN_API, {
        email,
      });

      console.log("RESETPASSTOKEN RESPONSE............", response);

      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      toast.success("Reset Email Sent");
      setEmailSent(true);
    } catch (error) {
      console.log("RESETPASSTOKEN ERROR............", error);
      toast.error("Failed To Send Reset Email");
    }
    toast.dismiss(toastId);
    dispatch(setLoading(false));
  };
}

export function resetPassword(password, confirmPassword, token, navigate) {
  return async (dispatch) => {
    const toastId = toast.loading("Loading...");
    dispatch(setLoading(true));
    try {
      const response = await apiConnector("POST", RESETPASSWORD_API, {
        password,
        confirmPassword,
        token,
      });

      console.log("RESETPASSWORD RESPONSE............", response);

      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      toast.success("Password Reset Successfully");
      navigate("/");
    } catch (error) {
      console.log("RESETPASSWORD ERROR............", error);
      toast.error("Failed To Reset Password");
    }
    toast.dismiss(toastId);
    dispatch(setLoading(false));
  };
}

//edit user
// Edit user details
export function editUser(name, role, studentClass) {
  return async (dispatch) => {
    const toastId = toast.loading("Updating user...");
    const token = JSON.parse(localStorage.getItem("token"));
    dispatch(setLoading(true));

    try {
      const response = await apiConnector(
        "PUT",
        EDIT_USER_API,
        { name, role, studentClass },
        {
          Authorization: `Bearer ${token}`,
        }
      );

      console.log("EDIT_USER_API RESPONSE............", response);

      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      // Update the user in Redux store
      dispatch(setUser({ ...response.data.user }));

      toast.success("User updated successfully");
    } catch (error) {
      console.log("EDIT_USER_API ERROR............", error);
      toast.error("Could not update user");
    }

    dispatch(setLoading(false));
    toast.dismiss(toastId);
  };
}

// services/operations/authAPI.js
export function getUser(token) {
  return async (dispatch) => {
    //const toastId = toast.loading("Loading...");
    const token = JSON.parse(localStorage.getItem("token"));
    dispatch(setLoading(true));

    try {
      const response = await apiConnector("GET", GET_USER_API, null, {
        Authorization: `Bearer ${token}`,
      });

      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      dispatch(setUser({ ...response.data.user }));
    } catch (error) {
      localStorage.removeItem("token");
      dispatch(setUser(null));
      dispatch(setToken(null));

      toast.error("Session expired, please login again.");
    }

    //  toast.dismiss(toastId);
    dispatch(setLoading(false));
  };
}

// services/operations/authAPI.js
export function getUserById(userid) {
  return async (dispatch) => {
    //const toastId = toast.loading("Loading...");
    dispatch(setLoading(true));

    try {
      const response = await apiConnector("POST", GET_USER_BY_ID_API, {
        userid,
      });

      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      return response.data.user;
      //console.log("response",response)
    } catch (error) {
     // toast.error("Fail To Fetched");
    }

    //  toast.dismiss(toastId);
    dispatch(setLoading(false));
  };
}
// same as getuserbyid but (non-thunk)
export const fetchUserById = async (userid) => {
  try {
    const response = await apiConnector("POST", GET_USER_BY_ID_API, { userid });

    if (!response.data.success) {
      throw new Error(response.data.message);
    }
// console.log("name",response)
    return response.data.user; // { name: "User Name", ... }
  } catch (error) {
    console.error("Failed to fetch user:", error);
    return null;
  }
};

//get School student
export function getAllStudents() {
  return async (dispatch) => {
    const token = JSON.parse(localStorage.getItem("token"));
    try {
      const response = await apiConnector("GET", GET_ALL_STUDENT_API, null, {
        Authorization: `Bearer ${token}`,
      });

      if (!response.data.success) {
        throw new Error(response.data.message);
      }
      console.log("student",response.data)
      return response.data;
    } catch (error) {
      console.error("Error fetching students:", error);
      toast.error(
        error?.response?.data?.message ||
          "Failed to fetch students. Please login again."
      );
    }
  };
}

export function getAllTeachers() {
  return async (dispatch) => {
    const token = JSON.parse(localStorage.getItem("token"));
    try {
      const response = await apiConnector("GET", GET_ALL_TEACHER_API, null, {
        Authorization: `Bearer ${token}`,
      });

      if (!response.data.success) {
        throw new Error(response.data.message);
      }
      // console.log("teacher",response.data)
      return response.data;
    } catch (error) {
      console.error("Error fetching students:", error);
      toast.error(
        error?.response?.data?.message ||
          "Failed to fetch students. Please login again."
      );
    }
  };
}

//register
export function register(
  name,
  email,
  password,
  confirmPassword,
  role,
  schoolId,
  phoneno,
  navigate
) {
  return async (dispatch) => {
    const toastId = toast.loading("Loading...");
    // dispatch(setLoading(true));
    try {
      if (password !== confirmPassword) {
        throw new Error("Passwords do not match");
      }
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await apiConnector(
        "POST",
        REGISTER_API,
        {
          name,
          email,
          password,
          confirmPassword,
          role,
          schoolId,
          phoneno,
        },
        {
          Authorization: `Bearer ${token}`,
        }
      );

      //  console.log("REGISTRATION API RESPONSE............", response);

      if (!response.data.success) {
        throw new Error(response.data.message);
      }
      toast.success("Register Successful");
      navigate(-1);
    } catch (error) {
      // console.log("REGISRATION API ERROR............", error);
      toast.error(
        error?.response?.data?.message || error?.message || "Signup Failed"
      );
    }
    //spatch(setLoading(false));
    toast.dismiss(toastId);
  };
}

//get all users
export function getAllUsers() {
  return async (dispatch) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await apiConnector("GET", GET_ALL_USERS_API, null, {
        Authorization: `Bearer ${token}`,
      });

      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      return response.data.users;
    } catch (error) {
      // console.error("GET_ALL_USERS ERROR:", error);
      return [];
    }
  };
}

//edit user
export function editUserAdmin(userId, updatedData, onSuccess) {
  return async (dispatch) => {
    const toastId = toast.loading("Updating user...");
    //dispatch(setLoading(true));
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await apiConnector(
        "PUT",
        EDIT_USER_ADMIN_API(userId),
        updatedData,
        {
          Authorization: `Bearer ${token}`,
        }
      );

      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      toast.success("User updated successfully");
      onSuccess && onSuccess(response.data.user); // Optional callback
    } catch (error) {
      //  console.error("EDIT_USER ERROR:", error);
      toast.error(error?.response?.data?.message || "Failed to update user");
    }
    toast.dismiss(toastId);
    // dispatch(setLoading(false));
  };
}

//delete user
export function deleteUser(userId, onSuccess) {
  return async (dispatch) => {
    const toastId = toast.loading("Deleting user...");
    //dispatch(setLoading(true));
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await apiConnector(
        "DELETE",
        DELETE_USER_API(userId),
        null,
        {
          Authorization: `Bearer ${token}`,
        }
      );

      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      toast.success("User deleted successfully");
      onSuccess && onSuccess(); // Optional callback to refresh UI
    } catch (error) {
      // console.error("DELETE_USER ERROR:", error);
      toast.error(error?.response?.data?.message || "Failed to delete user");
    }
    toast.dismiss(toastId);
    // dispatch(setLoading(false));
  };
}

// services/operations/authAPI.js
export function signUp(
  signupData,
  navigate,
  redirectTo = -1,
  url = SIGNUP_API
) {
 // console.log("data",signupData)
  return async (dispatch) => {
    const toastId = toast.loading("Loading...");
    dispatch(setLoading(true));

    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await apiConnector(
        "POST",
        url,
        {
          ...signupData,
          class: signupData.class, // ensure backend "class" gets correct value
        },
        {
          Authorization: `Bearer ${token}`,
        }
      );

     // console.log("SIGNUP API RESPONSE............", response);

      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      toast.success("Signup Successful");
      navigate(redirectTo);
    } catch (error) {
      // console.log("SIGNUP API ERROR............", error?.response?.data?.message);
      toast.error(
        error?.response?.data?.errors?.map((e) => e.msg) ||
          error?.response?.data?.message ||
          "Signup Failed"
      );
      // Public signup stays on the form so the user can fix the error
      if (redirectTo === -1) navigate(-1);
    }

    dispatch(setLoading(false));
    toast.dismiss(toastId);
  };
}

//login with otp
// export function login(email, password, otp, navigate) {
//   return async (dispatch) => {
//     const toastId = toast.loading("Loading...");
//     dispatch(setLoading(true));
//     try {
//       const response = await apiConnector("POST", LOGIN_API, {
//         email,
//         password,
//         otp,
//       });

//       // console.log("LOGIN API RESPONSE............", response);

//       if (!response.data.success) {
//         throw new Error(response.data.message);
//       }

//       toast.success("Login Successful");
//       dispatch(setToken(response.data.token));

//       dispatch(setUser({ ...response.data.user }));
//       console.log("auth user",response.data.user)
//       //localStorage.setItem("token", response.data.token);
//       localStorage.setItem("token", JSON.stringify(response.data.token));
//       navigate("/dashboard");
//     } catch (error) {
//       // console.log("LOGIN API ERROR............", error);
//       toast.error(error.response.data.message);
//     }
//     dispatch(setLoading(false));
//     toast.dismiss(toastId);
//   };
// }

//login
export function login(email, password, navigate) {
  return async (dispatch) => {
    const toastId = toast.loading("Loading...");
    dispatch(setLoading(true));
    try {
      const response = await apiConnector("POST", LOGIN_API, {
        email,
        password,
      });

      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      toast.success("Login Successful");
      dispatch(setToken(response.data.token));
      dispatch(setUser({ ...response.data.user }));
      
      localStorage.setItem("token", JSON.stringify(response.data.token));
      navigate("/dashboard");
    } catch (error) {
      toast.error(error.response?.data?.message || "Login Failed");
    }
    dispatch(setLoading(false));
    toast.dismiss(toastId);
  };
}

export function sendOtp(email, password, navigate) {
  console.log("email, password,",email, password)
  return async (dispatch) => {
    const toastId = toast.loading("Loading...");
    dispatch(setLoading(true));
    try {
       console.log("api", SENDOTP_API);
      const response = await apiConnector("POST", SENDOTP_API, {
        email,
        password,
          checkUserPresent: true,
      });
       console.log("SENDOTP API RESPONSE............", response);

      // console.log(response.data.success);

      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      toast.success("OTP Sent Successfully");
      navigate("/verify-email");
    } catch (error) {
      // console.log("SENDOTP API ERROR............", error);
      toast.error(error.response.data.message);
    }
    dispatch(setLoading(false));
    toast.dismiss(toastId);
  };
}

//get school users
export function getSchoolUsers() {
  return async (dispatch) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await apiConnector("GET", GET_SCHOOL_USERS_API, null, {
        Authorization: `Bearer ${token}`,
      });

      if (!response.data.success) {
        throw new Error(response.data.message);
      }
//console.log("GET_SCHOOL_USERS_API :", response.data.users);
      return response.data.users;
    } catch (error) {
      // console.error("GET_SCHOOL_USERS_API ERROR:", error);
      return [];
    }
  };
}

export function logout(navigate) {
  return (dispatch) => {
    dispatch(setToken(null));
    dispatch(setUser(null));
    dispatch(clearUser());
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.clear();
    toast.success("Logged Out");
    navigate("/login", { replace: true });
  };
}
